.image-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.image {
  display: block;
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: auto;
  object-fit: contain;
}

.right-image-container img {
  pointer-events: none;
}

.ion-grid {
    display: flex;
    justify-content: space-between;
}

.buttons-between {
  display: none;
}

.mobile-button {
    display: none;
  }

@media screen and (max-width: 768px) {
  ion-page {
    overflow-y: auto;
    scrollbar-width: thin;
  }

  .ion-grid {
    flex-direction: column;
  }
  
  .ion-row {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
    
  .image-container {
    width: 100%;
  }
  
  .col-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .buttons-between {
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 1rem 0;
  }

  .mobile-button {
    display: block;
  }

  .desktop-buttons {
    display: none;
  }
}